import React from 'react';
import { Target, Zap, ShieldCheck, TrendingUp } from 'lucide-react';

const PositioningSection: React.FC = () => {
  const pillars = [
    {
      icon: <Zap className="w-6 h-6 text-[#C5A059]" />,
      title: "Investor-Ready",
      desc: "Businesses structured for banks, PE firms, and institutional lenders."
    },
    {
      icon: <ShieldCheck className="w-6 h-6 text-[#C5A059]" />,
      title: "ESG-Aligned",
      desc: "Transparent operations that meet global procurement standards."
    },
    {
      icon: <Target className="w-6 h-6 text-[#C5A059]" />,
      title: "Globally Visible",
      desc: "Commercial entities discovered by international procurement teams."
    },
    {
      icon: <TrendingUp className="w-6 h-6 text-[#C5A059]" />,
      title: "Market Strength",
      desc: "Negotiate with buyers from a position of institutional clarity."
    }
  ];

  return (
    <section className="py-32 bg-[#010712] flex justify-center px-4">
      <div className="w-full max-w-[1440px] px-4 md:px-8 flex flex-col gap-16">
        
        {/* Narrative Header - Level 1 label */}
        <div className="max-w-4xl">
          <span className="text-zinc-400 text-[10px] md:text-[11px] font-bold uppercase tracking-[0.3em] mb-6 block">
            Our Mandate
          </span>
          <h3 className="text-3xl md:text-5xl font-bold tracking-tight leading-tight text-white mb-8">
            We Are Not a Marketing Agency. We Are a Capital Enablement Partner.
          </h3>
          <p className="text-zinc-400 text-base md:text-lg leading-relaxed">
            High-value African mines are systematically undervalued because they are poorly positioned. We specialize in transforming under-represented operations into bankable businesses.
          </p>
        </div>

        {/* Grid of Pillars - Glass Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {pillars.map((item, idx) => (
            <div 
              key={idx} 
              className="p-10 bg-[#0a1220]/50 hover:bg-[#0a1220]/80 transition-all rounded-none shadow-none group"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-[#111d30] rounded-none mb-6 transition-all group-hover:bg-[#1b2b42]">
                {item.icon}
              </div>
              <h4 className="font-bold text-[15px] uppercase tracking-widest mb-3 text-white">
                {item.title}
              </h4>
              <p className="text-sm text-zinc-400 leading-relaxed max-w-md">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PositioningSection;
